import { createContext, useContext, useReducer } from 'react';

const SelectParcelContext = createContext(null);

export const useSelectParcelContext = () => {
  const ctx = useContext(SelectParcelContext);
  if (!ctx) throw new Error('useSelectParcelContext doit être utilisé dans <SelectParcelProvider>');
  return ctx;
};

const initialState = { fetchAlert: false, alertMessage: '' };

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_SELECT_PARCEL_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function SelectParcelProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <SelectParcelContext.Provider value={{ ...state, dispatch }}>
      {children}
    </SelectParcelContext.Provider>
  );
}
